module.exports = [{
      plugin: require('D:/Documents/Projects/jambp/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/Documents/Projects/jambp/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#a0a0ff","showSpinner":false},
    },{
      plugin: require('D:/Documents/Projects/jambp/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
